// extracted by mini-css-extract-plugin
export default {"marquee":"Marquee_marquee__4nbAi","line":"Marquee_line__p8s0g","icon":"Marquee_icon__MEAYw","black":"Marquee_black__qJisK"};